import React from "react";
import { Form, Button, Row, Col, Spin, Image } from "antd";
import { LockOutlined } from "@ant-design/icons";
import AdnInput from "../../common/adnInput/AdnInput";
import { AdnValidationPassword } from "../LoginValidations";
import AdnLogo from "../../../assets/images/adentis-novo-logo-branco-horizontal.svg";
import AdnLoginBg from "../../../assets/images/adentis-login-bg.jpg";
import "./../LoginForm.css";

function RecoverPageForm({ handleRecover, loading, title, submitLoading }) {
  return (
    <div className="login-container">
      <Row className="login-row">
        <Col xs={0} sm={6} md={12} lg={14} xl={16} className="login-image-col">
          <Image src={AdnLoginBg} preview={false} className="login-image" />
          <Image src={AdnLogo} preview={false} wrapperClassName="login-logo" />
        </Col>
        <Col xs={24} sm={18} md={12} lg={10} xl={8} className="login-form-col">
          {loading ? (
            <Spin></Spin>
          ) : (
            <Form
              name="normal_login"
              className="login-form"
              layout="vertical"
              initialValues={{
                remember: true,
              }}
              onFinish={handleRecover}
            >
              <h1>{title}</h1>
              <AdnInput
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="Password"
                name="password"
                // rules={AdnValidationPassword}
                maxLength="30"
                validateTrigger="onSubmit"
              />
              <AdnInput
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="Password Confirmation"
                name="passwordConfirmation"
                rules={[
                  {
                    required: true,
                    message: "Password Confirmation is required",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (
                        !value ||
                        !getFieldValue("password") ||
                        getFieldValue("password") === value
                      ) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match")
                      );
                    },
                  }),
                ]}
                maxLength="30"
                validateTrigger="onSubmit"
              />
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  loading={submitLoading}
                >
                  Confirm
                </Button>
              </Form.Item>
            </Form>
          )}
        </Col>
      </Row>
    </div>
  );
}

export default RecoverPageForm;
